import { CareerMoney } from './CareerMoney';
import { CareerDocuments } from './CareerDocuments';
import { CareerStats } from './CareerStats';
import { CareerDevelopment } from './CareerDevelopment';
import type { CareerSection } from '../routes/route';

export interface CareerProps {
  tenantId: string;
  section: CareerSection;
  onViewSource: (sourceId: string) => void;
  /** R4 (Actionable Everywhere): drill a read-only rollup (a Stats metric, a
   *  Development theme/feedback card) down to the records behind it. */
  onNavigate: (path: string) => void;
}

// B4b: the Career section dispatcher. The main nav stays put; the strip
// (Money / Documents / Development / Stats) switches the section — Money is the
// default. B7 replaces the Development placeholder with the real coach-feedback
// insight rollup (CareerDevelopment).
export function Career({ tenantId, section, onViewSource, onNavigate }: CareerProps) {
  switch (section) {
    case 'money':
      return <CareerMoney tenantId={tenantId} />;
    case 'documents':
      return <CareerDocuments tenantId={tenantId} onViewSource={onViewSource} />;
    case 'stats':
      return <CareerStats tenantId={tenantId} onNavigate={onNavigate} />;
    case 'development':
    default:
      return <CareerDevelopment tenantId={tenantId} onNavigate={onNavigate} />;
  }
}
